import Simple from './simple'
import Toggle from './toggle'
import DropDown from './dropDown'

const Button = Simple
Button.Toggle = Toggle
Button.DropDown = DropDown

export default Button
